/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-09-14 15:28:14
 * @LastEditors: SYY 188842798@qq.com
 * @LastEditTime: 2025-07-09 17:31:27
 */
import router from "./router";
import store from "./store/";
import { cache } from "@/utils/common";

// const whiteList = ["login"]; //路由白名单.

router.beforeEach((to, from, next) => {
  if (to.path == "/user/report/inspection-info") {
    next();
    return;
  }
  if (process.env.NODE_ENV === "development") {
    cache.set("user", {
      openId: "omUQcxFHtI8LAIDVs_dmOqnQYzgM",
      bookingPaymentMode: 2, //
      token:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzX3dlY2hhdF9vcGVuaWQiOiJ3ZWNoYXJfdGVzdF9vcGVuaWQiLCJuYmYiOiIxNzUyMDUzNDQxIiwiZXhwIjoiMTc1MjA2MDY0MSIsImlzcyI6Im9wdV9iaGl3eCIsImF1ZCI6Im9wdV9iaGl3eCJ9.O8HaVU0a69Ck9P30EKZw5vHKdmMAiKRw3tf3p8SiIZM",
      wxHeadImgUrl:
        "http://thirdwx.qlogo.cn/mmopen/vi_32/ZunaDIIwlPuPWiaH0GDS6dEHw9ice3Nf7v12qRBLT9bibAh40xl5TZQ3uSwfmStFWYfwgqz5oPKibxwXH18BicvniaUQ/132",
      wxNickName: "test",
      enabledMobileTodayRegistration: true,
      enabledMobileBookingRegistration: true,
      enabledMobileMyInHospital: true,
    });
  }
  const user = cache.get("user");
  if (!user) {
    store.dispatch("login", to).then(() => {
      next({
        ...to,
      });
    });
  } else {
    next();
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

router.afterEach(() => {});
